import { render, staticRenderFns } from "./user-add.vue?vue&type=template&id=3ace556e&scoped=true&"
import script from "./user-add.vue?vue&type=script&lang=js&"
export * from "./user-add.vue?vue&type=script&lang=js&"
import style0 from "./user-add.vue?vue&type=style&index=0&id=3ace556e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace556e",
  null
  
)

export default component.exports